// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonAuth = {
  username: "Username",
  password: "Password",
  captcha: "Captcha",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmNewPassword: "Confirm new password",
  localLogin: "Local login",
  hybridLogin: "SSO preferred with local account sign-in",
  ssoLogin: "SSO login",
} as const;
